import React, { Fragment } from 'react'




//componets
import ThemeMenuThree from '../../../components/header/ThemeMenuThree'
import PageTitle from '../../../components/page-title/PageTitle'
import ProjectGridOne from '../../../components/project/ProjectGridOne'
import NewsletterTwo from '../../../components/call-to-action/NewsletterTwo'
import FooterThree from '../../../components/footer/FooterThree'
import { Link } from 'react-router-dom'


const ProjectGrid = () => {

    return (
        <Fragment>
            <div className="main-page-wrapper">
                {/* Helmet start */}
                {/* Helmet end */}

                {/* ThemeMenuThree */}
                <ThemeMenuThree />
                {/* ThemeMenuThree */}

                {/* PageTitle */}
                <PageTitle
                    title="구축 사례"
                    parentTo="/"
                    parentLabel="홈"
                />
                {/* PageTitle */}

                {/*codam-project-one start*/}
                <section className="codam-project-one pt-145 pb-105 pt-lg-55 pb-lg-15">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center justify-content-center">
                            <div className="col-xl-5 col-lg-6 col-md-8">
                                <div className="section-title text-center mb-25">
                                    <h3 className="sect-title mb-25" data-aos="fade-up">주요 프로젝트</h3>
                                    <p data-aos="fade-up">
                                        디지털 자산 거래 플랫폼 웹 개발(프로 거래 화면·마켓·주문), 블록체인·Web3, B2C 웹·모바일 앱(Android·iOS), 엔터프라이즈 소프트웨어, 보안까지 CODAM이 함께한 대표
                                        구축 사례입니다. 상단 탭에서 분야별로 모아 볼 수 있으며, 카드를 누르면 상세 사례 페이지로 이동합니다.
                                    </p>
                                </div>
                            </div>
                        </div>
                        {/* ProjectGridOne start */}
                        <ProjectGridOne />
                        {/* ProjectGridOne end */}
                        <div className="row">
                            <div className="col-lg-12 text-center mt-10 mb-45">
                                <Link className="theme_btn" to="/project-masonry">더 많은 사례 보기</Link>
                            </div>
                        </div>
                    </div>
                </section>
                {/*codam-project-one end*/}

                {/*codam-newsletter start*/}
                <NewsletterTwo />
                {/*codam-newsletter end*/}

                {/* FooterThree start */}
                <FooterThree />
                {/* FooterThree end */}

            </div>

        </Fragment>
    )
}

export default ProjectGrid
